const closeSelectDropdown = (root) => {
  const trigger = root.querySelector("[data-backoffice-select-trigger]")
  const menu = root.querySelector("[data-backoffice-select-menu]")
  if (!trigger || !menu) return

  menu.hidden = true
  trigger.setAttribute("aria-expanded", "false")
  trigger.classList.remove("is-open")
}

const openSelectDropdown = (root) => {
  const trigger = root.querySelector("[data-backoffice-select-trigger]")
  const menu = root.querySelector("[data-backoffice-select-menu]")
  if (!trigger || !menu) return

  document.querySelectorAll("[data-backoffice-select]").forEach((other) => {
    if (other !== root) closeSelectDropdown(other)
  })

  menu.hidden = false
  trigger.setAttribute("aria-expanded", "true")
  trigger.classList.add("is-open")
  trigger.focus({ preventScroll: true })
}

const syncSelectFieldState = (root, trigger, field) => {
  if (!trigger || !field) return

  const hasValue = field.value.trim() !== ""
  const valueLabel = root.querySelector("[data-backoffice-select-label]")
  const floatingWrapper = root.closest(".form__floating_label_wrapper")
  const fieldLabel = floatingWrapper?.querySelector(".form__floating_label")

  trigger.classList.toggle("is-placeholder", !hasValue)
  trigger.classList.toggle("form__input--filled", hasValue)

  if (floatingWrapper) {
    floatingWrapper.classList.toggle("form__floating_label_wrapper--input-filled", hasValue)
  }

  if (!valueLabel) return

  if (hasValue) {
    const activeOption = root.querySelector("[data-backoffice-select-option].is-active")
    const optionLabel = activeOption?.dataset.label || activeOption?.textContent?.trim()
    if (optionLabel) valueLabel.textContent = optionLabel
    return
  }

  if (fieldLabel) {
    valueLabel.textContent = ""
  } else {
    valueLabel.textContent = root.dataset.backofficeSelectPlaceholder || "Choisir…"
  }
}

const bindSelectDropdown = (root) => {
  if (root.dataset.bound === "true") return
  root.dataset.bound = "true"

  const trigger = root.querySelector("[data-backoffice-select-trigger]")
  const menu = root.querySelector("[data-backoffice-select-menu]")
  const field = root.querySelector("[data-backoffice-select-field]")
  if (!trigger || !menu || !field) return

  syncSelectFieldState(root, trigger, field)

  trigger.addEventListener("click", (event) => {
    event.preventDefault()
    event.stopPropagation()
    if (menu.hidden) openSelectDropdown(root)
    else closeSelectDropdown(root)
  })

  trigger.addEventListener("blur", () => {
    window.setTimeout(() => {
      if (menu.hidden) trigger.classList.remove("is-open")
    }, 0)
  })

  menu.addEventListener("click", (event) => {
    event.stopPropagation()
  })

  menu.querySelectorAll("[data-backoffice-select-option]").forEach((option) => {
    option.addEventListener("click", (event) => {
      event.preventDefault()
      const value = option.dataset.value ?? ""
      const optionLabel = option.dataset.label || option.textContent.trim()

      field.value = value
      const valueLabel = root.querySelector("[data-backoffice-select-label]")
      if (valueLabel) valueLabel.textContent = optionLabel

      syncSelectFieldState(root, trigger, field)

      menu.querySelectorAll("[data-backoffice-select-option]").forEach((item) => {
        const active = item === option
        item.classList.toggle("is-active", active)
        item.setAttribute("aria-selected", active ? "true" : "false")
      })

      closeSelectDropdown(root)
      field.dispatchEvent(new Event("input", { bubbles: true }))
      field.dispatchEvent(new Event("change", { bubbles: true }))
    })
  })
}

const initBackofficeSelectDropdown = () => {
  document.querySelectorAll("[data-backoffice-select]").forEach(bindSelectDropdown)
}

document.addEventListener("click", () => {
  document.querySelectorAll("[data-backoffice-select]").forEach(closeSelectDropdown)
})

document.addEventListener("keydown", (event) => {
  if (event.key !== "Escape") return
  document.querySelectorAll("[data-backoffice-select]").forEach(closeSelectDropdown)
})

document.addEventListener("turbolinks:before-cache", () => {
  document.querySelectorAll("[data-backoffice-select]").forEach((root) => {
    closeSelectDropdown(root)
    root.dataset.bound = "false"
  })
})

export { initBackofficeSelectDropdown }
